import React from 'react';

// Text and links displayed at the bottom of the app

const BottomNav = () => {
  return (
    <footer className="bottom-nav">
      <a href="https://github.com/AliTechGeek52">© Ali Raza</a>
      <a
        className="vector-credit"
        href="https://www.freepik.com/free-photos-vectors/house"
      >
        House vector created by Rawpixel.com - Freepik.com
      </a>
    </footer>
  );
};

export default BottomNav;
